import React, { useEffect, useMemo, useState } from 'react'
import { Item } from '../../../common/snippets'
import { Stack, TableCell, TableRow, Box, Button } from '@mui/material'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import moment from 'moment'
import autoTable from 'jspdf-autotable'
import { focusElemnt, getText, navigation3 } from '../../../common/helper'
import { viewColumns } from './constants'
import useToken from '../../../helpers/useTokens'
import LineinputV2 from '../../../common/lineinputV2'
import { useAtom } from 'jotai'
import { alertAtom } from '../../../common/jotaiState/globalStateAtoms'
import { PostRequest, PostRequestV2 } from '../../../common/api'
import { urls, xlCol } from '../../../common/constants'
import { showReportAtom } from './atoms'
import VirtualizedTable from '../../../common/virtualisedTable'
import { withPercentWidths, withPxWidths } from '../../../common/mathHelper'
import { useTheme } from '@mui/system'
import Alert from '../../../common/alert'
import { updateAlertError } from '../../../../store/common/common_action'
import { CargoRoleRightsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { exportToExcel } from '../../../common/hook'
import { fixColSpan } from '../../Reports/common/reportUtils'
import { makeTable } from '../../Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../common/AcountingConstants'
import SearchFilter from '../../../common/SearchFilter'
const BranchwiseCollectionAndDispatchMemoCollectionTable = (props) => {
  const { sourceBranch, sourceCity } = props
  const { headerData, reportName, tableData = [], roleName, onRefreshReport } = props
  const theme = useTheme()
  const { tableHeaderColor } = theme
  const { loginData } = useToken()
  const { intCompanyID, intUserID, strCompanyName } = loginData
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  const { AllowExportExcel = 1, AllowPrintandPdf = 1 } = { ...roleRightsData }
  const [alert, setAlert] = useAtom(alertAtom)
  const [, setShowReport] = useAtom(showReportAtom)

  const [filterData, setFilterData] = useState([])
  const [searchResult, setSearchResult] = useState(true)

  const [matches, setMatches] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const tables = [
    { id: 'mainTable', data: filterData, columnDefs: viewColumns, totalColDef: [] },
  ];

  const criteriaHeaders = [
    { header: 'Company', field: "Company", xlCol, textAlign: 'left' },
    { header: 'City', field: "City", xlCol, textAlign: 'left' },
    { header: 'Branch', field: "Branch", xlCol, textAlign: 'left' },
  ]
  const criteriaData = [
    {
      Company: strCompanyName,
      City: sourceCity?.CityName,
      Branch: sourceBranch?.BranchName,
      dataType: 'entry',
    }
  ]
  const filteredViewColumns = viewColumns.filter(col => !(roleName !== 'MTPL Admin' && roleName !== 'Admin' && col.field === 'Action'));
  const excelHeaders = filteredViewColumns.filter((obj) => obj.field !== 'Action').flatMap((col) => {
    if (typeof col.field === 'string' && col.field.includes('^^')) {
      const [field1, field2] = col.field.split('^^')
      const [header1, header2] = (col.exportHead || '').split('\n')
      return [
        { field: field1, header: header1, align: col.align },
        { field: field2, header: header2, align: col.align },
      ]
    }
    return { ...col, field: col.field, header: col.exportHead?.replace(/\n/g, ' '), align: col.align }
  })
  const [criteriaHeaderExcel, criteriaDataExcel] = fixColSpan(criteriaHeaders, criteriaData, excelHeaders)
  const header1 = [
    [
      { header: `Report For: ${reportName}`, field: '', span: 6, mainHeader: true },
      { header: `Company Name : ${loginData.strCompanyName}`, field: '', span: 7 },
    ],
  ]
  const excelHeaderList = [header1, criteriaHeaderExcel, excelHeaders]
  const excelDataList = [[], criteriaDataExcel]
  excelDataList.push(filterData)


  const formatData = (arr = []) => {
    const totals = arr.reduce(
      (acc, curr) => {
        acc.BusCollectionAmt += Number(curr.BusCollectionAmt) || 0;
        acc.CargoCollectionAmt += Number(curr.CargoCollectionAmt) || 0;
        acc.ClosingBalance += Number(curr.ClosingBalance) || 0;
        acc.OldReceivedAmt += Number(curr.OldReceivedAmt) || 0;
        acc.OldReceivedBankAmt += Number(curr.OldReceivedBankAmt) || 0;
        acc.OpeningBalance += Number(curr.OpeningBalance) || 0;
        acc.ReceivedAmt += Number(curr.ReceivedAmt) || 0;
        acc.ReceivedBankAmt += Number(curr.ReceivedBankAmt) || 0;
        acc.openingblnc += Number(curr.openingblnc) || 0;
        acc.TotalAmount += Number(curr.TotalAmount) || 0;
        return acc;
      },
      {
        BusCollectionAmt: 0,
        CargoCollectionAmt: 0,
        ClosingBalance: 0,
        OldReceivedAmt: 0,
        OldReceivedBankAmt: 0,
        OpeningBalance: 0,
        ReceivedAmt: 0,
        ReceivedBankAmt: 0,
        openingblnc: 0,
        TotalAmount: 0,
      }
    );

    // Format all totals to 2 decimal places
    const formattedTotals = Object.fromEntries(
      Object.entries(totals).map(([key, value]) => [key, value.toFixed(2)])
    );

    const updatedData = [
      ...tableData,
      { ...formattedTotals, isTotal: true, sn: "Total", dataType: 'total', colSpan: { 'sn': 3 } }
    ];
    return updatedData
  }

  let reportData = useMemo(() => {
    if (Array.isArray(tableData) && tableData.length > 0) {
      return formatData(tableData)
    } else {
      return []
    }
  }, [tableData])
  useEffect(() => {
    setFilterData(reportData)
  }, [reportData]);


  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')

  const handleTableSave = async (item) => {
    const { ID, BranchID, OldReceivedAmt, OldReceivedBankAmt, OldRemarks: rawRemarks } = item
    const OldRemarks = rawRemarks ?? '';
    if (!OldReceivedAmt) {
      setAlert({ show: true, msg: 'Please enter Received Cash Amount', nextId: '' })
    } else if (!OldReceivedBankAmt) {
      setAlert({ show: true, msg: 'Please enter Received Online Amount', nextId: '' })
    }
    else {
      const data = {
        CompanyID: intCompanyID,
        BranchID: BranchID,
        ID: ID || 0,
        ReceivedAmount: +OldReceivedAmt || 0,
        ReceivedBankAmount: +OldReceivedBankAmt || 0,
        Remarks: OldRemarks,
        ReceivedBy: intUserID,
      }
      const res = await PostRequest(urls.branchCollectionUpdate, data)
      if (res.status === 'Success') {
        setAlert({ show: true, success: true, msg: 'Branch collection updated successfully', nextId: '' })
        const refreshedReportData = await onRefreshReport?.()
        if (refreshedReportData) {
          setFilterData(formatData(refreshedReportData))
        }
        setShowReport(false)
        const smsdata = {
          intCompanyID: intCompanyID,
          intBranchID: BranchID,
          strType: 'FB',
          CashReceivedAmt: +OldReceivedAmt || 0,
          BankReceivedAmt: +OldReceivedBankAmt || 0,
          intUserID: intUserID,
        }
        const res = await PostRequestV2(urls.sendCargoSMSDirectBranchWise, smsdata)
        if (res.status === 'Success') {
          setShowReport(false)
        } else {
          setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
        }
      } else {
        setAlert({ show: true, msg: res.ErrMessage, nextId: '' })
      }
    }
  }
  const handleTableCancel = (index) => {
    let newData = [...filterData]
    console.log(index, 'index')
    if (index >= 0 && index <= newData?.length) {
      newData[index].OldReceivedAmt = filterData[index].ReceivedAmt
      newData[index].OldReceivedBankAmt = filterData[index].ReceivedBankAmt
      newData[index].OldRemarks = filterData[index].Remarks
      setFilterData(newData)
    }
  }
  const handleInputChange = (e, index, key) => {
    let newVal = [...filterData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index][key] = e.target.value
      setFilterData(newVal)
    }
  }
  const getNumberWithMinusAndDecimal = (value) => {
    let newValue = value.trim();
    if (newValue.startsWith('-')) {
      newValue = '-' + newValue.slice(1).replace(/[^0-9.]/g, '');
    } else {
      newValue = newValue.replace(/[^0-9.]/g, '');
    }
    const parts = newValue.split('.');
    if (parts.length > 2) {
      newValue = parts[0] + '.' + parts.slice(1).join('').replace(/\./g, '');
    } else if (parts.length === 2) {
      newValue = parts[0] + '.' + parts[1].slice(0, 2);
    }
    return newValue;
  };

  const subHeadingStyle = {
    minHeight: '36px',
    fontSize: '12px',
    color: '#444',
    padding: '6px 4px',
    fontFamily: 'Roboto',
    fontWeight: '600',
    backgroundColor: tableHeaderColor?.isSubHeadingColor,

    position: 'sticky',
  }
  const headerContent = () => {
    let viewHeader = withPercentWidths(filteredViewColumns)
    return (
      <>
        <TableRow>
          {viewHeader.map((item) => {
            return (
              <TableCell
                style={{
                  backgroundColor: tableHeaderColor?.isHeadingColor,
                  color: '#444',
                  fontSize: '12px',
                  lineHeight: '16px',
                  // letterSpacing: '0.24px',
                  fontWeight: '700',
                  whiteSpace: 'pre-line',
                  padding: '6px 4px',
                  width: item.width,
                  textAlign: item.align || 'left',
                }}
                colSpan={1}
              >
                {item?.headerName}
              </TableCell>
            )
          })}
        </TableRow>
        <TableRow style={{ color: 'white' }}>
          <TableCell
            className="ReportItemHead"
            style={{ ...subHeadingStyle, textAlign: 'left', }}
            colSpan={4}
          >
            {strCompanyName}
          </TableCell>
          <TableCell
            className="ReportItemHead"
            style={{ ...subHeadingStyle, textAlign: 'center' }}
            colSpan={4}
          >
            {sourceCity?.CityName}
          </TableCell>
          <TableCell
            className="ReportItemHead"
            style={{ ...subHeadingStyle, textAlign: 'right', }}
            colSpan={5}
          >
            {sourceBranch?.BranchName}
          </TableCell>
        </TableRow>
      </>
    )
  }
  const bodyContent = (index, obj, extra) => {
    return <DisPatchBody row={obj} index={index} tableHeaderColor={tableHeaderColor} columnDefs={filteredViewColumns} matches={extra.matchSet} currentMatch={extra.currentMatch}
      handleTableSave={handleTableSave}
      roleName={roleName}
      handleInputChange={handleInputChange}
      getNumberWithMinusAndDecimal={getNumberWithMinusAndDecimal}
      handleTableCancel={handleTableCancel}
    />
  }


  const printClick = (isSave) => {
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumns = criteriaHeaders.map((col) => {
      return { header: col.header, dataKey: col.field, xlCol: col.xlCol || xlCol }
    })
    let defPDFColumn = filteredViewColumns.map((obj) => ({ ...obj, weight: 80 })).filter((obj) => obj.field !== 'Action')
    const pdfFontSize = 1
    const orientation = defPDFColumn.length > 14 ? 'l' : 'p'
    const format = orientation === 'l' ? [1810, 1280] : [1280, 1810]
    const pdfColumns = withPxWidths(defPDFColumn, format[0] - 60).map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol, width: col.width || 0 }
    })
    const doc = new jsPDF({ orientation: orientation, format: format, unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `${reportName}.pdf`,
      subject: `${reportName}`,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    const customFunction = (data, doc) => {
      doc.setTextColor(40)
      doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
      doc.setFontSize(26).setFont('Roboto', 'bold')
      doc.setTextColor(16, 79, 162)
      doc.text(`Cargo System | ${reportName}`, 30 + 60, 80)
      doc.setTextColor(0, 0, 0)
      doc.setFontSize(22).setFont('Roboto', 'bold')
      doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
    }
    const customFunction2 = (data, doc) => {
      lrDetailPdfFooter(data, loginData, totalPagesExp)
    }
    makeTable(doc, autoTable, HeaderColumns, criteriaData, pdfFontSize, reportName, loginData, 'everyPage', customFunction, 120, false)
    makeTable(doc, autoTable, pdfColumns, filterData, pdfFontSize, reportName, loginData, 'everyPage', customFunction2)

    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`${reportName} ${currentDateTime}.pdf`)
    } else {
    }
    setTimeout(() => {
      const pdfUrl = doc.output('bloburl')
      document.getElementById('anaLRDetailsOutput').data = pdfUrl
      // document.getElementById('anaLRDetailsOutput').data = doc.output('datauristring', `${reportName}.pdf`)
      focusElemnt('backBtn')
    }, 2000)
  }

  const handleAlert = (msg = false, nextId = '') => {
    if (!(msg instanceof Event)) {
      if (msg) {
        setAlert({ show: true, msg })
      } else {
        setAlert({ show: false, msg: '' })
        setTimeout(() => {
          focusElemnt(nextId)
        }, 0)
      }
    }
    updateAlertError({ show: false, msg: '' })
  }
  return (
    <>
      <SearchFilter
        tables={tables}
        matches={matches}
        setMatches={setMatches}
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
      />
      <Item className="userReport">
        <Item style={{ padding: '8px 0 0 8px' }} className="userReport-heading">
          Report For:{reportName} Report
        </Item>
        <Item className="userReport-buttons">
          {searchResult ? (
            <>
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  disabled={!AllowExportExcel}
                  onClick={() =>
                    exportToExcel({
                      fileName: `${reportName} ${currentDateTime}.xlsx`,
                      sheetName: reportName,
                      headersList: excelHeaderList,
                      dataList: excelDataList,
                    })
                  }
                >
                  Export to Excel
                </Button>
              </Box>

              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setSearchResult(false)
                    printClick(true)
                  }}
                  disabled={!AllowPrintandPdf}
                  onKeyDown={(e) =>
                    navigation3(e, 'analPrintBtn', !AllowPrintandPdf ? '' : 'analsExpToExlbtn', () => {
                      setSearchResult(false)
                      printClick(true)
                    })
                  }
                  id="anaxportAsPdfBtn"
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => {
                    setSearchResult(false)
                    printClick(false)
                  }}
                  disabled={!AllowPrintandPdf}
                  id="analPrintBtn"
                  onKeyDown={(e) =>
                    navigation3(e, '', 'anaxportAsPdfBtn', () => {
                      setSearchResult(false)
                      printClick(false)
                    })
                  }
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => setSearchResult(true)}
                  onKeyDown={(e) =>
                    navigation3(e, '', 'generateButton', () => {
                      setSearchResult(true)
                      focusElemnt('generateButton')
                    })
                  }
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Item>
      </Item>

      {searchResult ? (
        <>
          <Stack style={{ margin: '0px 10px' }}>
            <VirtualizedTable
              id="mainTable"
              tableData={filterData}
              headerContent={headerContent}
              rowContent={bodyContent}
              tableStyle={{ tableLayout: 'auto', width: '100%' }}
              autoResize={true}
              matches={matches}
              currentIndex={currentIndex}
            />
          </Stack>
        </>
      ) : (
        <object
          id="anaLRDetailsOutput"
          type="application/pdf"
          width={'100%'}
          height={`${window.innerHeight - 100}px`}
          title={`MTLPL -Cargo System -${reportName}`}
          aria-label={`MTLPL -Cargo System -${reportName}`}
        ></object>
      )}
      {alert.show && (
        <Alert
          msg={alert.msg}
          error={!alert?.success}
          success={alert?.success || false}
          close={() => (alert.close ? alert.close() : handleAlert(false, alert.nextId))}
        />
      )}
    </>
  )
}

const DisPatchBody = ({ row, index, tableHeaderColor, columnDefs, matches, currentMatch,
  handleTableSave = () => { },
  roleName,
  handleInputChange = () => { },
  getNumberWithMinusAndDecimal,
  handleTableCancel = () => { }
}) => {
  if (!row?.dataType) return null
  const getStyles = (field, align) => {
    const common = {
      minHeight: '36px',
      fontSize: '12px',
      color: '#444',
      padding: '6px 4px',
      fontFamily: 'Roboto'
    }
    if (row.dataType === 'header') {
      return {
        ...common,
        fontWeight: '700',
        backgroundColor: row?.backgroundColor ?? tableHeaderColor?.isHeadingColor,
        textAlign: align,
        whiteSpace: 'pre-line',
      }
    }
    if (row.dataType === 'entry') {
      return {
        ...common,
        fontWeight: '500',
        textAlign: align || 'left',
        height: '36px',
        whiteSpace: 'pre-line',
      }
    }
    if (row.dataType === 'subHeader') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: row?.backgroundColor ?? tableHeaderColor?.isSubHeadingColor,
        textAlign: row.align?.[field] || 'left',
        position: 'sticky',
      }
    }
    if (row.dataType === 'total') {
      return {
        ...common,
        fontWeight: '600',
        backgroundColor: tableHeaderColor?.isTotalColor,
        textAlign: row.align?.[field] || 'right',
      }
    }
  }
  return (
    <>
      {(() => {
        let skip = 0

        return columnDefs.map((item, i) => {
          if (skip > 0) {
            skip--
            return null
          }
          let colSpan = row.colSpan?.[item.field] || 1



          skip = colSpan - 1
          const key = `${index}-${item.field}`
          const isMatched = matches?.has(key)
          const isActive =
            currentMatch &&
            currentMatch.rowIndex === index &&
            currentMatch.field === item.field


          return (
            <TableCell
              data-field={item.field}   // 👈 ADD THIS LINE
              className="reportTD"
              key={item.field + i + index}
              colSpan={colSpan}
              style={{
                ...getStyles(item.field, item.align),
                ...(item.width
                  ? {
                    minWidth: item.width,
                    width: item.width,
                    whiteSpace: 'pre-line',
                    wordBreak: 'break-word'
                  }
                  : {
                    whiteSpace: 'pre-line',
                  }),
              }}
            >
              <span
                style={{
                  backgroundColor: isActive
                    ? 'orange'
                    : isMatched
                      ? 'yellow'
                      : 'transparent',
                }}
              >
                {(row.IsReceivable === 1 && item.field === 'OldReceivedAmt') && row.dataType !== 'total' ? (
                  <div
                    className={'input--wrapper right'}
                    style={{ maxHeight: roleName !== 'MTPL Admin' && roleName !== 'Admin' ? '40px' : '25px', display: 'flex', alignItems: 'center', marginBottom: '0px' }}
                  >
                    <LineinputV2
                      filter={getNumberWithMinusAndDecimal}
                      value={row.OldReceivedAmt}
                      onBlur={(e) => {
                        handleInputChange(e, index, 'OldReceivedAmt')
                      }}
                      disabled={roleName !== 'MTPL Admin' && roleName !== 'Admin'}
                    />
                  </div>
                ) : (row.IsReceivable === 1 && item.field === 'OldReceivedBankAmt') && row.dataType !== 'total' ? (
                  <div
                    className={'input--wrapper right'}
                    style={{ maxHeight: roleName !== 'MTPL Admin' && roleName !== 'Admin' ? '40px' : '25px', display: 'flex', alignItems: 'center', marginBottom: '0px' }}
                  >
                    <LineinputV2
                      filter={getNumberWithMinusAndDecimal}
                      value={row.OldReceivedBankAmt}
                      onBlur={(e) => {
                        handleInputChange(e, index, 'OldReceivedBankAmt')
                      }}
                      disabled={roleName !== 'MTPL Admin' && roleName !== 'Admin'}
                    />
                  </div>
                ) : (row.IsReceivable === 1 && item.field === 'OldRemarks') && row.dataType !== 'total' ? (
                  <div
                    className={'input--wrapper'}
                    style={{
                      maxHeight: roleName !== 'MTPL Admin' && roleName !== 'Admin' ? '25px' : '25px', alignItems: 'center',
                    }}
                  >
                    <LineinputV2
                      filter={getText}
                      value={row.OldRemarks}
                      onBlur={(e) => {
                        handleInputChange(e, index, 'OldRemarks')
                      }}
                      disabled={roleName !== 'MTPL Admin' && roleName !== 'Admin'}
                    />
                  </div>
                ) : item.field === 'Action' ? ((roleName !== 'MTPL Admin' && roleName !== 'Admin') || row.dataType === 'total') ? <></> : (
                  <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'end' }}>
                    <>
                      <Box>
                        <Button
                          variant="outlined"
                          className="userWisereporttembtn"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTableCancel(index)
                          }}
                          style={{ fontSize: '14px', cursor: 'pointer', height: '30px' }}
                          onKeyDown={(e) => navigation3(e, 'PrintBtn', 'ExpToExlbtn', () => { })}
                          id="PdfBtn"
                          disabled={!(row.IsReceivable === 1)}
                        >
                          Reset
                        </Button>
                      </Box>
                      <Box>
                        <Button
                          type="button"
                          variant="contained"
                          className="btn btn-primary"
                          style={{ fontSize: '14px', cursor: 'pointer', height: '30px' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleTableSave(row)
                          }}
                          id="PrintBtn"
                          disabled={!(row.IsReceivable === 1)}
                          onKeyDown={(e) => navigation3(e, 'fromDate', 'PdfBtn', () => { })}
                        >
                          Save
                        </Button>
                      </Box>
                    </>
                  </Box>
                )
                  : row[item.field]}
              </span>
            </TableCell>
          )
        })
      })()}
    </>
  )
}
export default BranchwiseCollectionAndDispatchMemoCollectionTable
